var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('HeroSection',{on:{"nextPage":_vm.nextPage}}),_c('SolarPanel'),_c('div',{attrs:{"id":"services"}},[_c('GarageServices'),_c('MainServices'),_c('CustomerTestimonials'),_c('ServiceAreasSection')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }